<template lang="pug">
  .review-quote.container
    .row.text-center.xs-12.quote
      .internal-quote
        p.xs-f-small.sm-f-xxmedium.md-f-medium.lg-f-small {{quote}}
        
        .quote-sign.left-quote-sign(aria-hidden="true")
          img(v-if="quoteImage" :src="quoteImage.url" :alt="quoteImage.alt_text")
          span(v-else).ldquo.didot.xs-f-billboard.ui-color-4 &ldquo;

        .quote-sign.right-quote-sign(aria-hidden="true")
          img(v-if="quoteImage" :src="quoteImage.url" :alt="quoteImage.alt_text")
          span(v-else).ldquo.didot.xs-f-billboard.ui-color-4 &ldquo;

      p.customer-data.bold.brand-color-1.f-primary-bold.xs-f-xmedium.sm-f-xmedium.md-f-medium.lg-f-medium.max-at-tweak {{customerName}}{{customerLocation ? ` ${customerLocation}` : ''}}
</template>

<script>

  export default {
    name: 'ReviewQuote',

    props: {
      quote: {
        type: String,
        default() {
          return '';
        },
      },
      quoteImage: {
        type: Object,
        default() {
          return { url: '', 'alt_text': '' };
        },
      },
      customerName: {
        type: String,
        default() {
          return '';
        },
      },
      customerLocation: {
        type: String,
        default() {
          return '';
        },
      },
    },
  };
</script>

<style lang="stylus">
  .review-quote  
    .image-wrap
      padding-top 16px
      margin-bottom 9px

      img
        display block
        margin-left auto
        margin-right auto
        width 94px
        
    .quote
      margin 0px
      
      .internal-quote
        margin 0px
        margin-top 4px

        .quote-sign
          position absolute
          top 0
          z-index -4
          margin-top -20px
          
          img
            width 48px
            height 48px
          
          .ldquo
            font-size 11em

        .left-quote-sign
          left 0px
          margin-left -30px

        .right-quote-sign
          right 0px
          margin-right -30px
          transform rotate(180deg)

    .customer-data
      margin-top 14px
      margin-bottom 2px
    
    .cta-button
      cursor pointer
      background-color transparent
      border-width 1px
    
      &:hover
      &:focus
      &:active
        color #853585
</style>
